import { FunctionComponent } from 'react';
import ButtonLink from '../../components/ButtonLink';
import Layout from '../../layouts/Layout';
import { Features } from '../../components/Features';
import FAQs from '../../components/FAQs';
import styles from './styles.module.scss';
import { LogosStrip } from '../../components/LogosStrip';
import { useScroll } from '../../hooks/useScroll';
import PricingCards from '../../pages_components/pricing/PricingCards';

const PricingPage: FunctionComponent = () => {
    useScroll();

    return (
        <Layout
            title="Cademy Pricing"
            description="Cademy offers the most generous and flexible pricing plan in the industry. Get started for Free today!"
            path="pricing"
            shell={{ header: { showSearchBar: false } }}
        >
            <article>
                <section>
                    <div className="container">
                        <h1 style={{ textAlign: 'center' }}>Pricing</h1>
                        <PricingCards />
                    </div>
                </section>

                <section className={styles.logo_strip_wrapper}>
                    <div className="container">
                        <LogosStrip heading="Trusted By" category="educators" />
                    </div>
                </section>

                <section className={styles.section}>
                    <div className="container">
                        <h2 className="section_heading">Features</h2>
                        <Features />
                    </div>
                </section>

                <div className={styles.section}>
                    <div className={styles.faqs_container}>
                        <h2 className="section_heading">Frequently Asked Questions</h2>
                        <FAQs />
                        <div className={styles.cta_container}>
                            <ButtonLink
                                href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/create-educator`}
                                target="_blank"
                                preset="primary"
                            >
                                Try Cademy Now
                            </ButtonLink>
                        </div>
                    </div>
                </div>
            </article>
        </Layout>
    );
};

export default PricingPage;
